@use 'styles/variables';
@use 'styles/mixins';

.Container {
  @include mixins.fixed-top-left;
  z-index: variables.$ZSpinner;

  width: 100%;
  height: 100%;

  &_InBlock {
    position: absolute;
  }

  &_Center {
    position: absolute;
    top: 50%;
    left: 50%;

    transform: translate(-50%, -50%);
  }

  &_WithWhiteBackground {
    background-color: variables.$white;
  }
}
